import React from 'react';
import { Coffee, TrendingUp, Users } from "lucide-react";
import { OrganicBlob2, OrganicBlob3, CirclePattern } from "../../../shared/decorations/OrganicBlob";

function FeatureColumn({ icon, headline, body }) {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="mb-4">
        {icon}
      </div>
      <h3
        className="mb-3"
        style={{
          color: '#FAFAF8',
          fontSize: '22px',
          fontWeight: '600'
        }}
      >
        {headline}
      </h3>
      <p style={{ color: '#E8DCC4', fontSize: '16px', lineHeight: '1.6' }}>
        {body}
      </p>
    </div>
  );
}

export function WhatIsTribe() {
  return (
    <section className="px-6 relative overflow-hidden" style={{ paddingTop: '100px', paddingBottom: '100px', backgroundColor: '#1A1A1A' }}>
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <OrganicBlob3 className="absolute w-[450px] h-[450px] -left-32 top-0 animate-pulse" style={{ animationDelay: '1s' }} />
        <OrganicBlob2 className="absolute w-80 h-80 -right-20 bottom-10 animate-pulse" style={{ animationDelay: '0.5s' }} />
        <CirclePattern className="absolute w-56 h-56 left-1/3 top-20 opacity-30" />
      </div>

      <div className="max-w-[1100px] mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <FeatureColumn
            icon={<Coffee size={56} strokeWidth={1.5} style={{ color: '#8B9D83' }} />}
            headline="Your Daily Reset"
            body="Play a puzzle designed for Bison."
          />
          <FeatureColumn
            icon={<Users size={56} strokeWidth={1.5} style={{ color: '#8B9D83' }} />}
            headline="No Pressure Competition"
            body="Friendly leaderboards."
          />
          <FeatureColumn
            icon={<TrendingUp size={56} strokeWidth={1.5} style={{ color: '#8B9D83' }} />}
            headline="Track Your Streak"
            body="Build something consistent in the chaos."
          />
        </div>
      </div>
    </section>
  );
}
